<template>
  <div>
    <div class="wrapper" :class="(showConsent) ? 'show' : 'hide'">
        <header>
            <v-card-title style="cursor: pointer">
                <h2 class="primary--text">
                   {{ $t('app.cookie.consent.title') }}
                </h2>
            </v-card-title>
        </header>

        <div class="data">
            <v-card-text>
                {{ $t('app.cookie.consent.message') }}
            </v-card-text>
        </div>

        <v-card-actions class="buttons">
          <v-btn outline color="primary" @click="showPreferences" v-if="company.cookie_data">
              {{ $t('cookie.customize.label.text') }}
          </v-btn>
          <v-btn outline color="primary" @click="acceptCookies">
              {{ $t('app.cookie.consent.accept.btn.label') }}
          </v-btn>
          <v-btn outline color="primary" @click="showConsent = false">
              {{ $t('app.cookie.consent.decline.btn.label') }}
          </v-btn>
        </v-card-actions>

    </div>
    
    <v-dialog
      v-model="preferencesDialog"
      hide-overlay
      transition="dialog-bottom-transition"
      content-class="custom-dialog"
      max-width="700"
    >
      <v-card class="consent-popup">
        
        <div class="popup-header">
          <h2>{{ $t('cookie.customize.concent.text') }}</h2>
          <v-btn icon @click="preferencesDialog = false" class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <template v-if="cookieData.description">
          <div class="popup-description" v-html="cookieData.description[currentLocale]" />
        </template>
        
        <div class="cookie-section" v-for="(cookieSection, index) in cookieData.cookie_sections" :key="index">
          
          <div class="cookie-section-header" v-if="cookieSection.title">
            <span class="cookie-section-title">
              {{ cookieSection.title[currentLocale] }}
            </span>
            <template v-if="cookieSection.showSwitcher">
              <v-spacer></v-spacer>
              <v-switch
                class="switch-aligned"
              />
            </template>
          </div>

          <div class="cookie-details">
            <template v-if="cookieSection.description[currentLocale]">
              <div class="cookie-inner-detail" v-html="cookieSection.description[currentLocale]"></div>
            </template>
          </div>
        </div>
        
        <div class="popup-actions">
          <v-btn outlined color="primary" class="action-btn" @click="showConsent = false">{{ $t('cookie.customize.concent.btn.reject') }}</v-btn>
          <v-btn outlined color="primary" class="action-btn" @click="acceptCookies">{{ $t('cookie.customize.concent.btn.save.preferences') }}</v-btn>
          <v-btn color="primary" class="action-btn" dark @click="acceptCookies">{{$t('cookie.customize.concent.btn.accept.all')}}</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name : 'CookieConsent',
    data() {
        return {
          showConsent: false,
          preferencesDialog: false,
          cookieData: {}
        };
    },
    watch: {
      cookieData: {
        handler(newVal) {
          console.log(newVal);

          // Update cookie_sections in the company object or another appropriate place
          this.company = newVal;
        },
        deep: true
      }
    },
    mounted() {
      // Initialize cookieData from company.cookie_data
      if (this.company.cookie_data) {
        this.cookieData.description = this.company.cookie_data.description
        this.cookieData.cookie_sections = this.company.cookie_data.cookie_sections.map((item) => {
            return {
                expand: false,
                title: item.title,
                description: item.description,
                showSwitcher: item.showSwitcher,
            };
        });
      }
    },
    created() {
        // Check if user has already accepted cookies
        const consent = localStorage.getItem('cookieConsent')
        if (!consent) {
            this.showConsent = true
        }
    },
    computed:{
      ...mapState({
        company: (state) => state.company.company,
      }),
      currentLocale() {
        return this.$i18n.locale;
      }
    },
    methods: {
      acceptCookies() {
          // Save default preferences
          this.saveCookieConsent({
              analytics: true,
              marketing: false
          })
          this.showConsent = false
          this.preferencesDialog = false
      },
      showPreferences() {
          this.showConsent = false
          this.preferencesDialog = true
      },
      savePreferences() {
          this.saveCookieConsent(this.cookiePreferences)
          this.preferencesDialog = false
          this.showConsent = false
      },
      saveCookieConsent(preferences) {
          // Save preferences to localStorage
          localStorage.setItem('cookieConsent', JSON.stringify({
              accepted: true,
              timestamp: new Date().toISOString(),
              preferences
          }))

          
      }
    }
        
}
</script>

<style scoped>
.v-input {
    -ms-flex: none !important;
    flex: none !important;
}
.cookie-consent {
  max-width: none !important;
}
.wrapper {
  position: fixed;
  bottom: 50px;
  right: 0px;
  max-width: 430px;
  width: 100%;
  background: #fff;
  border-radius: 8px;
  padding: 15px 25px 22px;
  transition: right 0.3s ease;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
}
.wrapper.show {
  display: block;
  right: 20px;
}
.wrapper.hide {
  display: none;
}
.wrapper header {
  display: flex;
  align-items: center;
  column-gap: 15px;
}
header i {
  color: #4070f4;
  font-size: 32px;
}
header h2 {
  color: #4070f4;
  font-weight: 500;
}
.wrapper .data {
  margin-top: 12px;
  padding-left: 16px;
}
.wrapper .data p {
  color: #333;
  font-size: 16px;
}
.data p a {
  color: #4070f4;
  text-decoration: none;
}
.data p a:hover {
  text-decoration: underline;
}
/* .wrapper .buttons {
  margin-top: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 8px;
} */
.wrapper .buttons {
  margin-top: 16px;
  width: 100%;
  display: flex;
  flex-wrap: wrap; /* allow wrapping */
  gap: 10px; /* better spacing */
  justify-content: center; /* center buttons nicely */
  padding-left: 0; /* remove unnecessary padding */
}
.buttons .button {
  border: none;
  color: #fff;
  padding: 8px 0;
  border-radius: 4px;
  background: #4070f4;
  cursor: pointer;
  width: calc(100% / 2 - 10px);
  transition: all 0.2s ease;
}
.buttons #acceptBtn:hover {
  background-color: #034bf1;
}
#declineBtn {
  border: 2px solid #4070f4;
  background-color: #fff;
  color: #4070f4;
}
#declineBtn:hover {
  background-color: #4070f4;
  color: #fff;
}

/* Entry animation */
.custom-dialog {
  animation: slide-up 0.35s ease-out;
  border-radius: 12px;
}

/* Custom animation */
@keyframes slide-up {
  from {
    transform: translateY(100vh);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Popup box styles */
.consent-popup {
  padding: 24px;
  border-radius: 12px;
}

/* Header section */
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.popup-header h2 {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
}

/* Description */
.popup-description {
  font-size: 14px;
  color: #444;
  margin-bottom: 20px;
}

.popup-description a {
  color: #1e88e5;
  text-decoration: underline;
  font-weight: 500;
}

/* Section list */
.popup-section {
  border-top: 1px solid #ccc;
  padding-top: 16px;
  margin-bottom: 24px;
}

.section-item {
  margin-bottom: 16px;
}

.section-title {
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 4px;
}

.section-status {
  font-size: 14px;
  font-weight: 600;
}

.green-text {
  color: #43a047;
}

.section-description {
  font-size: 13px;
  color: #555;
}

/* Buttons */
.popup-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.action-btn {
  text-transform: none;
  font-weight: 500;
  min-width: 140px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.section-title {
  font-weight: bold;
  font-size: 15px;
}

.section-status {
  font-size: 14px;
  font-weight: 500;
  margin-top: 2px;
}

.switch-aligned {
  margin: 0;
  padding: 0;
  transform: scale(0.9);
}

/* Optional: make switch smaller and tighter */
.switch-sm {
  margin: 0;
  padding: 0;
  transform: scale(0.8);
}
.cookie-section {
  border-bottom: 1px solid #e0e0e0;
  padding: 16px 0;
}

.cookie-section-header {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.cookie-section-title {
  font-weight: bold;
  font-size: 16px;
  margin-left: 8px;
}

.cookie-section-description {
  font-size: 14px;
  color: #555;
  margin-top: 8px;
  padding-left: 24px;
}

.cookie-details {
  padding-left: 24px;
  padding-top: 8px;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
.cookie-inner-detail {
  color: #212121;
  background-color: #f4f4f4;
  border-color: #ebebeb;
  padding: 6px;
  border-radius: 5px;
}
</style>